import { VbzCheckbox } from '@smiles/voebiz-ui-kit';
import React, { FC, useEffect, useState } from 'react';

interface CheckboxProps {
  change: (status?: string) => void;
  status?: string;
}

export const Checkbox: FC<CheckboxProps> = ({ change, status }) => {
  const isBoth = status === 'both';

  const isEnabled = status === 'enabled';

  const isDisabled = status === 'disabled';

  const [statusEnabled, setStatusEnabled] = useState(isEnabled || isBoth);

  const [statusDisabled, setStatusDisabled] = useState(isDisabled || isBoth);

  useEffect(() => {
    const filterConfig = {
      both: statusEnabled && statusDisabled,
      enabled: statusEnabled,
      disabled: statusDisabled,
    };

    const newStatus = Object.keys(filterConfig).find((key) => filterConfig[key]);

    change(newStatus);
  }, [statusEnabled, statusDisabled, status, change]);

  const handleChangeCheckboxEnabled = () => {
    setStatusEnabled(!statusEnabled);
  };

  const handleChangeCheckboxDisabled = () => {
    setStatusDisabled(!statusDisabled);
  };

  return (
    <div className="modalcheckbox beneficiaries-checkbox-filter">
      <div className="checkboxhabilitado">
        <VbzCheckbox
          id="habilitado"
          label="Habilitado"
          checked={statusEnabled}
          onChange={handleChangeCheckboxEnabled}
        />
      </div>
      <div>
        <VbzCheckbox
          id="desabilitado"
          label="Desabilitado"
          checked={statusDisabled}
          onChange={handleChangeCheckboxDisabled}
        />
      </div>
    </div>
  );
};
